import Skeleton from 'react-loading-skeleton';

import Card, { CardAction, CardContent } from '@/components/@base/card';
import Container from '@/components/@base/container';
import Separator from '@/components/app/archive/components/separator';

export default function Loading() {
  return (
    <Card noBorder>
      <CardContent className='flex gap-4 p-4'>
        <Skeleton width={250} height={250} className='rounded-lg!' />
        <Container className='flex flex-1 flex-col justify-around'>
          <Container center className='gap-8'>
            <Container>
              <Skeleton width={250} height={18} />
              <Container center className='justify-start gap-2'>
                <Skeleton width={28} height={28} circle />
                <Skeleton width={100} height={14} />
              </Container>

              <Container className='my-2'>
                <Skeleton height={14} width={400} count={1.7} />
              </Container>
            </Container>
            <Container center className='mr-auto flex-col items-start gap-3.5'>
              <Skeleton width={120} height={28} />
              <Skeleton width={100} height={14} />
              <Skeleton width={100} height={14} />
            </Container>
          </Container>
          <Separator className='bg-[#F6F7F8]' />
          <Container center className='justify-between'>
            <CardAction center className='mr-auto mt-3 gap-3 p-0'>
              <Skeleton width={160} height={50} />
              <Skeleton width={160} height={50} />
            </CardAction>
          </Container>
        </Container>
      </CardContent>
    </Card>
  );
}
